(() => {
  'use strict';
  const url = new URL(location.href);
  if (url.searchParams.get('ss_card_customize') !== '1') return;
  const root = document.querySelector('[data-ss-pdp]');
  if (!root) return;
  // Consume this separate card handoff without changing the guided funnel state.
  url.searchParams.delete('ss_card_customize');
  history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  let stopped = false, pending = false;
  const stop = () => {
    stopped = true;
    observer.disconnect();
    clearTimeout(deadline);
    window.removeEventListener('options:rendered', attempt);
    window.removeEventListener('pointerdown', userInteraction, true);
  };
  const attempt = () => {
    if (stopped || pending) return;
    const input = root.querySelector('#live-product-options-atc input[type="radio"][name="properties[Customize The Bible]"][value="yes"]');
    const control = input?.closest('label');
    if (!control || input.disabled || !control.getClientRects().length) return;
    pending = true;
    // Use the same app control as the sticky button, after its bindings are ready.
    setTimeout(() => {
      if (stopped) return;
      const popup = document.querySelector('.cl-po--popup');
      const open = popup && popup.getClientRects().length && getComputedStyle(popup).visibility !== 'hidden';
      if (open) { stop(); return; }
      if (!control.isConnected || input.disabled) { pending = false; return; }
      control.click();
      setTimeout(() => {
        if (stopped) return;
        const editor = document.querySelector('.cl-po--popup');
        if (editor && editor.getClientRects().length && getComputedStyle(editor).visibility !== 'hidden') stop();
        else { pending = false; attempt(); }
      }, 400);
    }, 250);
  };
  const observer = new MutationObserver(attempt);
  const userInteraction = event => { if (event.isTrusted) stop(); };
  const deadline = setTimeout(stop, 20000);
  observer.observe(root, { childList: true, subtree: true, attributes: true });
  window.addEventListener('options:rendered', attempt);
  window.addEventListener('pointerdown', userInteraction, true);
  window.addEventListener('pagehide', stop, { once: true });
  attempt();
})();
